import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { style: {"height":"auto"} }
const _hoisted_2 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_8 = { style: {"margin":"0 10px"} }
const _hoisted_9 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_10 = {
  key: 1,
  class: "error-message"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "table-container" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_15 = { style: {"margin":"0 10px"} }
const _hoisted_16 = {
  key: 0,
  class: "organization-details-content"
}
const _hoisted_17 = {
  key: 0,
  style: {"margin-top":"20px"}
}
const _hoisted_18 = { class: "description-item-content-flex" }
const _hoisted_19 = { style: {"text-align":"right","margin-top":"20px"} }
const _hoisted_20 = { class: "registration-modal-content-scrollable" }
const _hoisted_21 = { style: {"text-align":"right","margin-top":"20px"} }
const _hoisted_22 = { style: {"text-align":"right"} }
const _hoisted_23 = {
  key: 0,
  style: {"text-align":"center","padding":"20px"}
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { style: {"text-align":"right","margin-top":"15px"} }

import { Organization, OrgUserBase, OrganizationType } from "@/model/organization";
import { ref, onMounted, h, computed } from "vue";
import { getCallable } from "@/config/env";
import {
  NSpace,
  NCard,
  NButton,
  NDataTable,
  NModal,
  NSelect,
  NDescriptions,
  NDescriptionsItem,
  useMessage,
  NTabs,
  NTabPane,
  useNotification,
  useDialog,
  DataTableColumns,
  NForm,
  NInput,
  NInputGroup,
  FormInst,
  FormRules,
  NIcon,
  NSpin,
  NFormItem, // Ensure NFormItem is imported if it wasn't explicitly for direct use
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import * as common from "@/assets/common/common";
import { useAuth } from "@/composables/useAuth";
import { QueryInfo } from "@/model/common";
import { usePagination } from "@/composables/usePagination";
import { USER_ROUTES } from "@/assets/route_constants";
import { useActionDialog } from "@/composables/useDialog";

export default /*@__PURE__*/_defineComponent({
  __name: 'Organization',
  setup(__props) {

const { show: showActionDialog } = useActionDialog();
const { isLoggedIn, loading } = useAuth();

const TAB = {
  PENDING: "pending",
  APPROVED: "approved",
};

const currentTab = ref("pending");
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const router = useRouter();
const createOrganizationCallable = getCallable("createOrganization");
const updateOrganizationCallable = getCallable("updateOrganization");
const getOrgsCallable = getCallable("getOrgs");
const getOrgRequestsCallable = getCallable("getOrgRequests");
const approveOrganizationRequestCallable = getCallable("approveOrganizationRequest");
const rejectOrganizationRequestCallable = getCallable("rejectOrganizationRequest");
const getOrgInfoCallable = getCallable("getOrgInfo");
const resetOrgAdminPasswordCallable = getCallable("resetOrgAdminPassword");
const checkOrgIdCallable = getCallable("checkOrgId");

// 사용자 관리 관련 Callable
const getOrgMembersCallable = getCallable("getOrgMembers");
const addOrgUserCallable = getCallable("addOrgUser");
const deleteOrgUserMemberCallable = getCallable("deleteOrgUserMember");
const updateOrgUserCallable = getCallable("updateOrgUser");


const searchValueForPending = ref<string | null>(null);
const searchTypeForPending = ref("name");
const searchValueForAccepted = ref<string | null>(null);
const searchTypeForAccepted = ref("name");

// 사용자 관리 모달 관련 상태
const showUserManagementModal = ref(false);
const selectedOrgForUserManagement = ref<Organization | null>(null);
const orgMembers = ref<any[]>([]);
const loadingOrgMembers = ref(false);

// 사용자 추가/수정 모달 관련 상태
const showUserEditModal = ref(false);
const isEditingUser = ref(false); // true: 수정, false: 추가
const userEditFormRef = ref<FormInst | null>(null);
const isSavingUser = ref(false);
const userEditFormData = ref({
  orgId: "",
  uid: "",
  password: "",
  confirmPassword: "",
  name: "",
  email: "",
  phoneNumber: "",
  role: "",
  position: "",
  description: "",
  type: "user", // 기본값: 일반사용자
});

const userEditFormRules = computed(() => {
  const rules: any = {
    name: [
      { required: true, message: "이름을 입력해주세요", trigger: "blur" }
    ],
    email: [
      {
        type: "email",
        message: "올바른 이메일 형식이 아닙니다",
        trigger: ["input", "blur"],
      }
    ]
  };

  if (!isEditingUser.value) {
    rules.uid = [
      { required: true, message: "아이디를 입력해주세요", trigger: "blur" }
    ];
    rules.password = [
      { required: true, message: "암호를 입력해주세요", trigger: "blur" }
    ];
    rules.confirmPassword = [
      {
        required: true,
        validator: (rule: any, value: string) => {
          if (!value) {
            return new Error("암호 확인을 입력해주세요");
          }
          if (value !== userEditFormData.value.password) {
            return new Error("암호가 일치하지 않습니다");
          }
          return true;
        },
        trigger: ["blur", "input"]
      }
    ];
  }
  return rules;
});


const searchOptions = [
  { label: "기관명", value: "name" },
  { label: "담당자이름", value: "deptPersonName" },
  { label: "이메일", value: "email" },
  { label: "전화번호", value: "phoneNumber" },
];

const {
  paginatedItems: organizations,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshOrganizations,
} = usePagination<Organization, { status?: string }>(
  async (params) => getOrganizationByStatus(params),
  25, // 페이지 크기
  { status: currentTab.value }
);

const getOrganizationByStatus = async (params: any) => {
  if (params.status == TAB.PENDING) {
    if (searchValueForPending.value && searchValueForPending.value.trim() !== "") {
      params.searchKey = searchTypeForPending.value;
      params.searchValue = searchValueForPending.value.trim();
    }

    return await getOrgRequestsCallable(params);
  } else if (params.status == TAB.APPROVED) {
    if (searchValueForAccepted.value && searchValueForAccepted.value.trim() !== "") {
      params.searchKey = searchTypeForAccepted.value;
      params.searchValue = searchValueForAccepted.value.trim();
    }

    return await getOrgsCallable(params);
  } else {
    return [];
  }
};

async function wrappedRefreshOrganizations(newFilters?: { status?: string }) {
  await composableRefreshOrganizations(newFilters);
}

const selectedOrganization = ref<Organization | null>(null);
const showRegistrationForm = ref<boolean>(false);
const showDetailsModal = ref<boolean>(false);
const componentKey = ref(0);
const isCheckingId = ref<boolean>(false);
const editableOrganizationDetails = ref<Partial<Organization>>({});
const typeOptions = ref([
  {
    label: "초등학교",
    value: OrganizationType.ElementarySchool,
  },
  { label: "중학교", value: OrganizationType.MiddleSchool },
  { label: "고등학교", value: OrganizationType.HighSchool },
  { label: "대학교", value: OrganizationType.University },
  { label: "기타 기관(법인/재단 등)", value: OrganizationType.Etc },
]);

const registrationFormRef = ref<FormInst | null>(null);
const registrationModel = ref<Partial<Organization>>({
  uid: "",
  name: "",
  president: "",
  address: {
    postCode: "",
    address: "",
    addressDetail: "",
  },
  dept: "",
  deptPersonName: "",
  deptPersonPhoneNumber: "",
  email: "",
  phoneNumber: "",
  description: "",
  type: null,
});
const idCheckMessage = ref<string>("");
const isIdAvailable = ref<boolean | null>(null);
const isRegisting = ref(false);
const isUpdating = ref(false);
const isApproving = ref<{ [key: string]: boolean }>({});
const isRejecting = ref<{ [key: string]: boolean }>({});

const registrationRules: FormRules = {
  uid: [{ required: true, message: "기관 ID를 입력해주세요.", trigger: ["input", "blur"] }],
  name: [{ required: true, message: "기관명을 입력해주세요.", trigger: ["input", "blur"] }],
  president: [{ required: true, message: "대표자 이름을 입력해주세요.", trigger: ["input", "blur"] }],
  dept: [{ required: true, message: "담당부서를 입력해주세요.", trigger: ["input", "blur"] }],
  deptPersonName: [{ required: true, message: "담당자 이름을 입력해주세요.", trigger: ["input", "blur"] }],
  deptPersonPhoneNumber: [{ required: true, message: "담당자 연락처를 입력해주세요.", trigger: ["input", "blur"] }],
  email: [
    { required: true, message: "이메일을 입력해주세요.", trigger: ["input", "blur"] },
    { type: "email", message: "올바른 이메일 형식이 아닙니다.", trigger: ["blur"] },
  ],
  phoneNumber: [
    { required: true, message: "전화번호를 입력해주세요.", trigger: ["input", "blur"] },
    {
      pattern: /^\d{2,3}-\d{3,4}-\d{4}$/,
      message: "전화번호 형식이 올바르지 않습니다. (예: 02-123-4567 또는 010-1234-5678)",
      trigger: ["blur"],
    },
  ],
  type: [{ required: true, message: "기관 유형을 선택해주세요.", trigger: "change" }],
};

const pendingOrgs = computed(() => {
  return organizations.value;
});

const approvedOrgs = computed(() => {
  return organizations.value;
});

function getTypeString(type: OrganizationType | null): string {
  switch (type) {
    case OrganizationType.ElementarySchool:
      return "초등학교";
      break;
    case OrganizationType.MiddleSchool:
      return "중학교";
      break;
    case OrganizationType.HighSchool:
      return "고등학교";
      break;
    case OrganizationType.University:
      return "대학교";
      break;
    case OrganizationType.Etc:
      return "기타 기관(법인/재단 등)";
      break;
    default:
      return "N/A";
  }
}

const baseColumns = [
  {
    title: "기관 ID",
    key: "SK",
    resizable: true,
    render(row: Organization) {
      if (row.SK && row.SK.includes("#")) {
        return row.SK.split("#")[1];
      }
      return row.SK;
    },
  },
  {
    title: "기관명",
    key: "name",
    resizable: true,
  },
  {
    title: "기관유형",
    key: "type",
    resizable: true,
    render(row: Organization) {
      return getTypeString(row.type);
    },
  },
  {
    title: "담당부서",
    key: "dept",
    resizable: true,
  },
  {
    title: "담당자이름",
    key: "deptPersonName",
    resizable: true,
  },
  {
    title: "이메일",
    key: "email",
    resizable: true,
  },
  {
    title: "전화번호",
    key: "phoneNumber",
    resizable: true,
  },
  {
    title: "등록일",
    key: "createdDate",
    resizable: true,
    render(row: Organization) {
      return common.getYYYYMMDD2(Number(row.createdDate));
    },
  },
  {
    title: "상세보기",
    key: "actions",
    render(row: Organization) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => displayOrganizationDetails(row),
        },
        { default: () => "상세" }
      );
    },
  },
];

const requestColumns = [
  ...baseColumns,
  {
    title: "승인",
    key: "actions",
    render(row: Organization) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          loading: isApproving.value[row.SK],
          onClick: () => approvedOrgRequest(row),
        },
        { default: () => "승인" }
      );
    },
  },
  {
    title: "거부",
    key: "actions",
    render(row: Organization) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          type: "error",
          size: "small",
          loading: isRejecting.value[row.SK],
          onClick: () => rejectOrgRequest(row),
        },
        { default: () => "거부" }
      );
    },
  },
];

const userTableColumns = [
  {
    title: "아이디",
    key: "userId",
    render(row: any) {
      return row.SK.split("#").pop() || "";
    }
  },
  {
    title: "이름",
    key: "name",
  },
  {
    title: "이메일",
    key: "email",
    render(row: any) {
      return row.email || "-";
    }
  },
  {
    title: "전화번호",
    key: "phoneNumber",
    render(row: any) {
      return row.phoneNumber || "-";
    }
  },
  {
    title: "구분",
    key: "type",
    render(row: any) {
      return row.type === "admin" ? "관리자" : "일반사용자";
    }
  },
  {
    title: "역할",
    key: "role",
    render(row: any) {
      return row.role || "-";
    }
  },
  {
    title: "직책",
    key: "position",
    render(row: any) {
      return row.position || "-";
    }
  },
  {
    title: "조작",
    key: "actions",
    render(row: any) {
      return h(NSpace, {}, {
        default: () => [
          h(
            NButton,
            {
              size: "small",
              type: "primary",
              onClick: () => openEditUserForm(row),
            },
            { default: () => "수정" }
          ),
          h(
            NButton,
            {
              size: "small",
              type: "error",
              onClick: () => handleDeleteUser(row),
            },
            { default: () => "삭제" }
          )
        ]
      });
    }
  }
];

const columns = [
  ...baseColumns,
  {
    title: "사용자 관리",
    key: "user_management",
    render(row: Organization) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => openUserManagementModal(row),
        },
        { default: () => "사용자 관리" }
      );
    },
  },
  {
    title: "견적서 작성",
    key: "actions",
    render(row: Organization) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => goToRegisterOrder(row.SK),
        },
        { default: () => "견적서 발행" }
      );
    },
  },
];


async function wrappedGoToNextPage() {
  if (hasNextPage.value) {
    await composableGoToNextPage();
  }
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value > 1) {
    await composableGoToPreviousPage();
  }
}

async function fetchOrganizationDetails(orgSK: string) {
  loading.value = true;
  error.value = null;
  try {
    const result = await getOrgInfoCallable({ SK: orgSK });
    const data = common.getItemFromFunctionResult(result);
    if (data) {
      const org: Organization = data as Organization; // Type assertion
      selectedOrganization.value = org;
      editableOrganizationDetails.value = {
        SK: org.SK,
        uid: org.uid,
        address: {
          postCode: org.address?.postCode || "",
          address: org.address?.address || "",
          addressDetail: org.address?.addressDetail || "",
        },
        name: org.name,
        president: org.president,
        type: org.type,
        dept: org.dept || "",
        deptPersonName: org.deptPersonName || "",
        deptPersonPhoneNumber: org.deptPersonPhoneNumber || "",
        email: org.email,
        phoneNumber: org.phoneNumber,
        description: org.description || "",
      };
      showDetailsModal.value = true;
    } else {
      throw new Error("해당 ID의 기관을 찾을 수 없습니다.");
    }
  } catch (err: any) {
    console.error(`기관 상세 정보 로딩 실패 (SK: ${orgSK}):`, err);
    error.value = `기관(SK: ${orgSK}) 상세 정보를 불러오는데 실패했습니다.`;
    selectedOrganization.value = null;
  } finally {
    loading.value = false;
  }
}

function displayOrganizationDetails(org: Organization) {
  showRegistrationForm.value = false;
  fetchOrganizationDetails(org.SK);
}

function goToRegisterOrder(orgSK: string) {
  router.push({ name: USER_ROUTES.OrgOrderRegister.Name, params: { SK: orgSK }, query: { origin: "Organization" } });
}

function closeDetailsModal() {
  showDetailsModal.value = false;
}
function onDetailsModalClose() {
  selectedOrganization.value = null;
  editableOrganizationDetails.value = {}; // Reset editable form data
}

async function approvedOrgRequest(org: Organization) {
  showActionDialog({
    title: "기관 등록 요청 승인 확인",
    content: `기관(${org.name}) 등록 요청을 승인하시겠습니까?\n승인 후 관리자 정보는 기관 이메일로 전송됩니다.`,
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: "승인 중...",
    onConfirm: async () => {
      isApproving.value[org.SK] = true;
      try {
        const result = await approveOrganizationRequestCallable(org);
        if (common.evalFunctionResult(result)) {
          message.success("기관 등록 요청 승인이 완료되었습니다. 관리자 정보는 기관 이메일로 발송됩니다.");
          await wrappedRefreshOrganizations({ status: currentTab.value }); // Refresh the list
        } else {
          notification.error({
            title: "기관 등록 요청 승인 오류",
            content: `기관 등록 요청 승인 중 오류가 발생했습니다. ${common.getResultMessage(result)}`,
            duration: 3000,
          });
        }
      } catch (error: any) {
        console.error("기관 등록 요청 승인 실패:", error);
        notification.error({
          title: "기관 등록 요청 승인 실패",
          content: `기관 등록 요청 승인 중 오류가 발생했습니다: ${error.message || error}`,
          duration: 3000,
        });
      } finally {
        isApproving.value[org.SK] = false;
      }
    },
  });
}
async function rejectOrgRequest(org: Organization) {
  showActionDialog({
    title: "기관 등록 요청 거부 확인",
    content: `기관(${org.name}) 등록 요청을 거부하시겠습니까?\n기관 이메일로 거부 되었음을 통보합니다.`,
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: "거부 중...",
    onConfirm: async () => {
      isRejecting.value[org.SK] = true;
      try {
        const result = await rejectOrganizationRequestCallable(org);
        if (common.evalFunctionResult(result)) {
          message.success("기관 등록 요청 거부가 완료되었습니다. 기관 이메일로 거부 되었음을 통보합니다.");
          await wrappedRefreshOrganizations({ status: currentTab.value }); // Refresh the list
        } else {
          notification.error({
            title: "기관 등록 요청 거부 오류",
            content: `기관 등록 요청 거부 중 오류가 발생했습니다. ${common.getResultMessage(result)}`,
            duration: 3000,
          });
        }
      } catch (error: any) {
        console.error("기관 등록 요청 거부 실패:", error);
        notification.error({
          title: "기관 등록 요청 거부 실패",
          content: `기관 등록 요청 거부 중 오류가 발생했습니다: ${error.message || error}`,
          duration: 3000,
        });
      } finally {
        isRejecting.value[org.SK] = false;
      }
    },
  });
}
async function resetOrgAdminPassword(orgSK: string | undefined) {
  if (!orgSK || !selectedOrganization.value) {
    message.error("기관 정보가 올바르지 않습니다.");
    return;
  }

  showActionDialog({
    title: "비밀번호 재설정 확인",
    content: `기관(${selectedOrganization.value.name})의 관리자 비밀번호를 재설정하시겠습니까?\n재설정한 비밀번호는 기관 이메일로 전송됩니다.`,
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: "요청 중...",
    onConfirm: async () => {
      try {
        const result = await resetOrgAdminPasswordCallable({ SK: orgSK });
        if (common.evalFunctionResult(result)) {
          message.success("비밀번호 재설정 요청이 완료되었습니다. 새 비밀번호는 관리자 이메일로 발송됩니다.");
        } else {
          notification.error({
            title: "재설정 오류",
            content: `비밀번호 재설정 중 오류가 발생했습니다. ${common.getResultMessage(result)}`,
            duration: 3000,
          });
        }
      } catch (error: any) {
        console.error("비밀번호 재설정 실패:", error);
        notification.error({
          title: "재설정 실패",
          content: `비밀번호 재설정 중 오류가 발생했습니다: ${error.message || error}`,
          duration: 3000,
        });
      }
    },
  });
}

// 기관 ID 중복 체크 함수
async function checkOrganizationId() {
  if (!registrationModel.value.uid) {
    idCheckMessage.value = "기관 ID를 먼저 입력해주세요.";
    isIdAvailable.value = false;
    return;
  }
  isCheckingId.value = true; // ID 중복 체크 로딩 시작
  idCheckMessage.value = "";
  isIdAvailable.value = null;
  try {
    const result: any = await checkOrgIdCallable({ id: registrationModel.value.uid }); // 파라미터도 uid로
    if (common.evalFunctionResult(result)) {
      const checkResult = common.getItemFromFunctionResult(result);
      if (checkResult) {
        idCheckMessage.value = "이미 사용 중인 ID입니다.";
        isIdAvailable.value = false;
      } else {
        idCheckMessage.value = "사용 가능한 ID입니다.";
        isIdAvailable.value = true;
      }
    } else {
      idCheckMessage.value = "ID 중복 체크 중 오류가 발생했습니다.";
      isIdAvailable.value = false;
    }
  } catch (error: any) {
    console.error("ID 중복 체크 실패:", error);
    idCheckMessage.value = "ID 중복 체크 중 오류가 발생했습니다.";
    isIdAvailable.value = false;
  } finally {
    isCheckingId.value = false; // ID 중복 체크 로딩 종료
  }
}

async function handleUpdateOrganization() {
  if (!editableOrganizationDetails.value.SK) {
    message.error("수정할 기관 정보가 없습니다.");
    return;
  }

  // Basic validation
  if (!editableOrganizationDetails.value.name?.trim()) {
    message.error("기관명은 필수입니다.");
    return;
  }
  if (!editableOrganizationDetails.value.type?.trim()) {
    message.error("기관유형은 필수입니다.");
    return;
  }
  if (!editableOrganizationDetails.value.email?.trim()) {
    message.error("이메일은 필수입니다.");
    return;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (editableOrganizationDetails.value.email && !emailRegex.test(editableOrganizationDetails.value.email)) {
    message.error("올바른 이메일 형식이 아닙니다.");
    return;
  }
  const phoneRegex = /^\d{2,3}-\d{3,4}-\d{4}$/;
  if (
    editableOrganizationDetails.value.phoneNumber &&
    editableOrganizationDetails.value.phoneNumber.trim() !== "" && // Allow empty if optional
    !phoneRegex.test(editableOrganizationDetails.value.phoneNumber)
  ) {
    message.error("전화번호 형식이 올바르지 않습니다. (예: 02-123-4567 또는 010-1234-5678)");
    return;
  }

  isUpdating.value = true;
  try {
    const payload: Partial<Organization> = { ...editableOrganizationDetails.value };

    // Convert empty strings for optional fields to undefined, if backend prefers that
    if (payload.dept === "") payload.dept = undefined;
    if (payload.deptPersonName === "") payload.deptPersonName = undefined;
    if (payload.description === "") payload.description = undefined;
    if (payload.phoneNumber === "") payload.phoneNumber = undefined; // Assuming phoneNumber can be optional

    const result = await updateOrganizationCallable(payload);
    if (common.evalFunctionResult(result)) {
      message.success("기관 정보가 성공적으로 수정되었습니다.");
      showDetailsModal.value = false;
      await wrappedRefreshOrganizations({ status: currentTab.value }); // Refresh the list
    } else {
      notification.error({
        title: "수정 실패",
        content: `기관 정보 수정 중 오류 발생: ${common.getResultError(result) || "알 수 없는 오류"}`,
        duration: 3000,
      });
    }
  } catch (err: any) {
    console.error("기관 정보 수정 실패:", err);
    notification.error({
      title: "수정 실패",
      content: `기관 정보 수정 중 오류 발생: ${err.message || "알 수 없는 오류"}`,
      duration: 3000,
    });
  } finally {
    isUpdating.value = false;
  }
}

async function handleRegistrationSubmit() {
  try {
    await registrationFormRef.value?.validate();
  } catch (errors) {
    message.error("입력 내용을 확인해주세요.");
    return;
  }

  if (isIdAvailable.value !== true) {
    message.error("기관 ID 중복 체크를 통과해야 합니다.");
    return;
  }
  isRegisting.value = true;
  try {
    const result = await createOrganizationCallable(registrationModel.value);
    if (common.evalFunctionResult(result)) {
      message.success("기관 등록 성공!"); // 임시
      showRegistrationForm.value = false;
      wrappedRefreshOrganizations({ status: currentTab.value }); // 목록 새로고침
    } else {
      const errorDetail = common.getResultError(result);
      notification.error({
        title: "등록 에러",
        content: `기관 등록 실패: ${errorDetail ? String(errorDetail) : "오류가 발생했습니다."}`,
        duration: 1500,
        closable: true,
      });
    }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    notification.error({
      title: "에러",
      content: `기관 등록 실패: ${errorMessage || "오류가 발생했습니다."}`,
      duration: 3000,
      closable: true,
    });
  } finally {
    isRegisting.value = false;
    return;
  }
}

function goToRegisterOrganization() {
  selectedOrganization.value = null;
  showRegistrationForm.value = true;
  showDetailsModal.value = false;
  registrationModel.value = {
    uid: "",
    name: "",
    president: "",
    type: "",
    address: {
      postCode: "",
      address: "",
      addressDetail: "",
    },
    dept: "",
    deptPersonName: "",
    deptPersonPhoneNumber: "",
    email: "",
    phoneNumber: "",
    description: "",
  };
  idCheckMessage.value = "";
  isIdAvailable.value = null;
}

async function handleTabChange(tabName: string) {
  organizations.value = [];
  await wrappedRefreshOrganizations({ status: tabName });
}

const openPostcodeSearch = () => {
  if (typeof (window as any).daum === "undefined" || typeof (window as any).daum.Postcode === "undefined") {
    message.error("Daum 우편번호 서비스가 로드되지 않았습니다. 페이지를 새로고침하거나 관리자에게 문의하세요.");
    return;
  }
  new (window as any).daum.Postcode({
    oncomplete: (data: any) => {
      let addr = "";
      let extraAddr = "";

      if (data.userSelectedType === "R") {
        addr = data.roadAddress;
      } else {
        addr = data.jibunAddress;
      }

      if (data.userSelectedType === "R") {
        if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
          extraAddr += data.bname;
        }
        if (data.buildingName !== "" && data.apartment === "Y") {
          extraAddr += extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
        }
        if (extraAddr !== "") {
          extraAddr = " (" + extraAddr + ")";
        }
      }

      if (registrationModel.value.address) {
        registrationModel.value.address.postCode = data.zonecode;
        registrationModel.value.address.address = addr + extraAddr;
      }
      document.getElementById("addressDetailInput")?.focus();
    },
  }).open();
};

// 1. 사용자 관리 모달 열기 및 조회
async function openUserManagementModal(org: Organization) {
  selectedOrgForUserManagement.value = org;
  showUserManagementModal.value = true;
  await fetchOrgMembers();
}

async function fetchOrgMembers() {
  if (!selectedOrgForUserManagement.value) return;
  loadingOrgMembers.value = true;
  try {
    const orgId = selectedOrgForUserManagement.value.SK && selectedOrgForUserManagement.value.SK.includes("#")
      ? selectedOrgForUserManagement.value.SK.split("#")[1]
      : selectedOrgForUserManagement.value.SK;
    
    const result = await getOrgMembersCallable({ orgId });
    orgMembers.value = common.getItemListFromFunctionResult(result) || [];
  } catch (err: any) {
    console.error("기관 멤버 조회 실패:", err);
    message.error("기관 멤버 정보를 불러오는데 실패했습니다.");
    orgMembers.value = [];
  } finally {
    loadingOrgMembers.value = false;
  }
}

// 2. 사용자 추가 모달 열기
function openAddUserForm() {
  if (!selectedOrgForUserManagement.value) return;
  
  const orgId = selectedOrgForUserManagement.value.SK && selectedOrgForUserManagement.value.SK.includes("#")
    ? selectedOrgForUserManagement.value.SK.split("#")[1]
    : selectedOrgForUserManagement.value.SK;

  isEditingUser.value = false;
  userEditFormData.value = {
    orgId: orgId,
    uid: "",
    password: "",
    confirmPassword: "",
    name: "",
    email: "",
    phoneNumber: "",
    role: "",
    position: "",
    description: "",
    type: "user",
  };
  showUserEditModal.value = true;
}

// 3. 사용자 수정 모달 열기
function openEditUserForm(user: any) {
  if (!selectedOrgForUserManagement.value) return;
  
  const orgId = selectedOrgForUserManagement.value.SK && selectedOrgForUserManagement.value.SK.includes("#")
    ? selectedOrgForUserManagement.value.SK.split("#")[1]
    : selectedOrgForUserManagement.value.SK;

  isEditingUser.value = true;
  userEditFormData.value = {
    orgId: orgId,
    uid: user.SK.split("#").pop() || "",
    password: "", // 수정 시에는 사용하지 않음
    confirmPassword: "",
    name: user.name || "",
    email: user.email || "",
    phoneNumber: user.phoneNumber || "",
    role: user.role || "",
    position: user.position || "",
    description: user.description || "",
    type: user.type || "user",
  };
  showUserEditModal.value = true;
}

// 4. 사용자 저장 (추가/수정 통합)
async function handleUserEditSubmit() {
  try {
    await userEditFormRef.value?.validate();
  } catch (errors) {
    return;
  }

  if (isEditingUser.value) {
    // 수정일 경우 경고 고지 및 동의 컨펌
    dialog.warning({
      title: "주의 사항 확인",
      content: "사용자 정보를 수정하더라도 이미 이 사용자가 담당자로 지정된 기존 진단 정보(학급 정보 등)에는 자동으로 반영되지 않습니다.\n기존 진단의 담당자 정보도 함께 업데이트하려면, 해당 진단의 상세 화면에서 '담당자 변경' 기능을 사용하여 재설정해야 합니다.\n\n정말로 이대로 정보를 수정하시겠습니까?",
      positiveText: "예, 수정합니다",
      negativeText: "취소",
      onPositiveClick: async () => {
        await executeUserSave();
      }
    });
  } else {
    // 추가일 경우 즉시 저장 실행
    await executeUserSave();
  }
}

async function executeUserSave() {
  isSavingUser.value = true;
  try {
    let result;
    if (isEditingUser.value) {
      // 수정 API 호출
      result = await updateOrgUserCallable({
        orgId: userEditFormData.value.orgId,
        uid: userEditFormData.value.uid,
        name: userEditFormData.value.name,
        email: userEditFormData.value.email || null,
        phoneNumber: userEditFormData.value.phoneNumber || null,
        role: userEditFormData.value.role || null,
        position: userEditFormData.value.position || null,
        description: userEditFormData.value.description || null,
      });
    } else {
      // 추가 API 호출
      result = await addOrgUserCallable({
        orgId: userEditFormData.value.orgId,
        uid: userEditFormData.value.uid,
        password: userEditFormData.value.password,
        name: userEditFormData.value.name,
        email: userEditFormData.value.email || null,
        phoneNumber: userEditFormData.value.phoneNumber || null,
        role: userEditFormData.value.role || null,
        position: userEditFormData.value.position || null,
        description: userEditFormData.value.description || null,
        type: userEditFormData.value.type,
      });
    }

    if (common.evalFunctionResult(result)) {
      notification.success({
        title: "성공",
        description: isEditingUser.value ? "사용자 정보가 수정되었습니다." : "사용자가 추가되었습니다.",
        duration: 2000,
      });
      showUserEditModal.value = false;
      await fetchOrgMembers(); // 목록 새로고침
    } else {
      notification.error({
        title: "실패",
        description: common.getResultError(result) || "처리에 실패했습니다.",
        duration: 3000,
      });
    }
  } catch (err: any) {
    console.error("사용자 저장 실패:", err);
    notification.error({
      title: "에러",
      description: "오류가 발생했습니다.",
      duration: 3000,
    });
  } finally {
    isSavingUser.value = false;
  }
}

// 5. 사용자 삭제
function handleDeleteUser(user: any) {
  const userId = user.SK.split("#").pop() || "";
  dialog.warning({
    title: "사용자 삭제",
    content: `정말로 사용자 [${userId}] (이름: ${user.name || "N/A"}) 계정을 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.`,
    positiveText: "삭제",
    negativeText: "취소",
    onPositiveClick: async () => {
      try {
        const orgId = selectedOrgForUserManagement.value!.SK && selectedOrgForUserManagement.value!.SK.includes("#")
          ? selectedOrgForUserManagement.value!.SK.split("#")[1]
          : selectedOrgForUserManagement.value!.SK;
          
        const result = await deleteOrgUserMemberCallable({
          orgId: orgId,
          uid: userId,
        });

        if (common.evalFunctionResult(result)) {
          notification.success({
            title: "성공",
            description: "사용자가 삭제되었습니다.",
            duration: 2000,
          });
          await fetchOrgMembers(); // 목록 새로고침
        } else {
          notification.error({
            title: "실패",
            description: common.getResultError(result) || "사용자 삭제에 실패했습니다.",
            duration: 3000,
          });
        }
      } catch (err: any) {
        console.error("사용자 삭제 실패:", err);
        notification.error({
          title: "에러",
          description: "오류가 발생했습니다.",
          duration: 3000,
        });
      }
    }
  });
}

onMounted(() => {

  wrappedRefreshOrganizations({ status: currentTab.value });
});

return (_ctx: any,_cache: any) => {
  const _component_n_alert = _resolveComponent("n-alert")!

  return (_openBlock(), _createElementBlock("div", {
    class: "main_div",
    key: componentKey.value
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NSpace), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[48] || (_cache[48] = [
                  _createElementVNode("div", { style: {"font-size":"20px","width":"150px","font-weight":"bold"} }, "기관 관리", -1)
                ])),
                _: 1
              }),
              _cache[59] || (_cache[59] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _withDirectives(_createVNode(Loading, null, null, 512), [
                [_vShow, _unref(loading)]
              ]),
              _createElementVNode("button", {
                onClick: goToRegisterOrganization,
                class: "action-button"
              }, "신규 기관 등록"),
              _createVNode(_unref(NTabs), {
                type: "line",
                animated: "",
                value: currentTab.value,
                "onUpdate:value": [
                  _cache[6] || (_cache[6] = ($event: any) => ((currentTab).value = $event)),
                  handleTabChange
                ],
                style: {"margin-top":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NTabPane), {
                    name: TAB.PENDING,
                    disabled: _unref(listLoading)
                  }, {
                    tab: _withCtx(() => [
                      _createVNode(_unref(NSpace), {
                        align: "center",
                        size: 8,
                        "wrap-item": false
                      }, {
                        default: _withCtx(() => [
                          _cache[49] || (_cache[49] = _createElementVNode("span", null, "등록 요청", -1)),
                          (_unref(listLoading) && currentTab.value === TAB.PENDING)
                            ? (_openBlock(), _createBlock(_unref(NSpin), {
                                key: 0,
                                size: "small"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(NSpace), {
                        vertical: "",
                        style: {"margin-top":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NSpace), {
                            align: "baseline",
                            "item-style": "display: flex;"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NFormItem), {
                                label: "검색",
                                style: {"min-width":"350px"},
                                "label-placement": "left"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NInputGroup), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NSelect), {
                                        value: searchTypeForPending.value,
                                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchTypeForPending).value = $event)),
                                        options: searchOptions,
                                        style: {"width":"120px"}
                                      }, null, 8, ["value"]),
                                      _createVNode(_unref(NInput), {
                                        value: searchValueForPending.value,
                                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchValueForPending).value = $event)),
                                        placeholder: "검색어를 입력하세요",
                                        clearable: ""
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(NFormItem), {
                                style: {"min-width":"300px"},
                                "label-placement": "left"
                              }),
                              _createVNode(_unref(NFormItem), { style: {"margin-bottom":"0"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NButton), {
                                    type: "primary",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (wrappedRefreshOrganizations({ status: TAB.PENDING })))
                                  }, {
                                    default: _withCtx(() => _cache[50] || (_cache[50] = [
                                      _createTextVNode(" 조회 ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("div", null, [
                        (_unref(listLoading))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "기관 등록 요청 목록을 불러오는 중..."))
                          : (_unref(error))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(error)), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                  (pendingOrgs.value.length > 0)
                                    ? (_openBlock(), _createBlock(_unref(NDataTable), {
                                        key: 0,
                                        columns: requestColumns,
                                        data: pendingOrgs.value,
                                        pagination: false,
                                        bordered: true
                                      }, null, 8, ["data"]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_6, "등록된 기관 등록 요청이 없습니다."))
                                ]),
                                (pendingOrgs.value.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                      _createVNode(_unref(NButton), {
                                        onClick: wrappedGoToPreviousPage,
                                        disabled: _unref(currentPage) === 1,
                                        style: {"margin-right":"8px"}
                                      }, {
                                        default: _withCtx(() => _cache[51] || (_cache[51] = [
                                          _createTextVNode(" 이전 페이지 ")
                                        ])),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                                      _createVNode(_unref(NButton), {
                                        onClick: wrappedGoToNextPage,
                                        disabled: !_unref(hasNextPage)
                                      }, {
                                        default: _withCtx(() => _cache[52] || (_cache[52] = [
                                          _createTextVNode(" 다음 페이지 ")
                                        ])),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                      ])
                    ]),
                    _: 1
                  }, 8, ["name", "disabled"]),
                  _createVNode(_unref(NTabPane), {
                    name: TAB.APPROVED,
                    disabled: _unref(listLoading)
                  }, {
                    tab: _withCtx(() => [
                      _createVNode(_unref(NSpace), {
                        align: "center",
                        size: 8,
                        "wrap-item": false
                      }, {
                        default: _withCtx(() => [
                          _cache[54] || (_cache[54] = _createElementVNode("span", null, "승인된 기관", -1)),
                          (_unref(listLoading) && currentTab.value === TAB.APPROVED)
                            ? (_openBlock(), _createBlock(_unref(NSpin), {
                                key: 0,
                                size: "small"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(NSpace), {
                        vertical: "",
                        style: {"margin-top":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NSpace), {
                            align: "baseline",
                            "item-style": "display: flex;"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NFormItem), {
                                label: "검색",
                                style: {"min-width":"350px"},
                                "label-placement": "left"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NInputGroup), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NSelect), {
                                        value: searchTypeForAccepted.value,
                                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchTypeForAccepted).value = $event)),
                                        options: searchOptions,
                                        style: {"width":"120px"}
                                      }, null, 8, ["value"]),
                                      _createVNode(_unref(NInput), {
                                        value: searchValueForAccepted.value,
                                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((searchValueForAccepted).value = $event)),
                                        placeholder: "검색어를 입력하세요",
                                        clearable: ""
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(NFormItem), {
                                style: {"min-width":"300px"},
                                "label-placement": "left"
                              }),
                              _createVNode(_unref(NFormItem), { style: {"margin-bottom":"0"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NButton), {
                                    type: "primary",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (wrappedRefreshOrganizations({ status: TAB.APPROVED })))
                                  }, {
                                    default: _withCtx(() => _cache[55] || (_cache[55] = [
                                      _createTextVNode(" 조회 ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _cache[58] || (_cache[58] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("div", null, [
                        (_unref(listLoading))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "기관 목록을 불러오는 중..."))
                          : (_unref(error))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(error)), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  (approvedOrgs.value.length > 0)
                                    ? (_openBlock(), _createBlock(_unref(NDataTable), {
                                        key: 0,
                                        columns: columns,
                                        data: approvedOrgs.value,
                                        pagination: false,
                                        bordered: true
                                      }, null, 8, ["data"]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_13, "등록된 기관이 없습니다."))
                                ]),
                                (approvedOrgs.value.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _createVNode(_unref(NButton), {
                                        onClick: wrappedGoToPreviousPage,
                                        disabled: _unref(currentPage) === 1,
                                        style: {"margin-right":"8px"}
                                      }, {
                                        default: _withCtx(() => _cache[56] || (_cache[56] = [
                                          _createTextVNode(" 이전 페이지 ")
                                        ])),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                                      _createVNode(_unref(NButton), {
                                        onClick: wrappedGoToNextPage,
                                        disabled: !_unref(hasNextPage)
                                      }, {
                                        default: _withCtx(() => _cache[57] || (_cache[57] = [
                                          _createTextVNode(" 다음 페이지 ")
                                        ])),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                      ])
                    ]),
                    _: 1
                  }, 8, ["name", "disabled"])
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(NModal), {
            show: showDetailsModal.value,
            "onUpdate:show": _cache[19] || (_cache[19] = ($event: any) => ((showDetailsModal).value = $event)),
            preset: "card",
            style: {"width":"800px"},
            title: "기관 상세 정보",
            onAfterLeave: onDetailsModalClose
          }, {
            default: _withCtx(() => [
              (selectedOrganization.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "left",
                      bordered: "",
                      column: 2,
                      size: "small",
                      class: "compact-descriptions"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "기관 ID",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrganization.value.SK && selectedOrganization.value.SK.includes("#")
                      ? selectedOrganization.value.SK.split("#")[1]
                      : selectedOrganization.value.SK), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "기관명",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "name",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editableOrganizationDetails.value.name,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((editableOrganizationDetails.value.name) = $event)),
                                  placeholder: "기관 전체 이름"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "대표자 이름",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "president",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editableOrganizationDetails.value.president,
                                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((editableOrganizationDetails.value.president) = $event)),
                                  placeholder: "대표자 이름"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "기관 유형",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "type",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NSelect), {
                                  value: editableOrganizationDetails.value.type,
                                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((editableOrganizationDetails.value.type) = $event)),
                                  placeholder: "기관 유형 선택",
                                  options: typeOptions.value
                                }, null, 8, ["value", "options"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "우편번호",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "address.postCode",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editableOrganizationDetails.value.address.postCode,
                                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((editableOrganizationDetails.value.address.postCode) = $event)),
                                  placeholder: "우편번호"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "주소",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "address.address",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editableOrganizationDetails.value.address.address,
                                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((editableOrganizationDetails.value.address.address) = $event)),
                                  placeholder: "주소"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "상세주소",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "address.addressDetail",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editableOrganizationDetails.value.address.addressDetail,
                                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((editableOrganizationDetails.value.address.addressDetail) = $event)),
                                  placeholder: "상세주소"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "담당부서" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "dept",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editableOrganizationDetails.value.dept,
                                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((editableOrganizationDetails.value.dept) = $event)),
                                  placeholder: "담당부서 이름"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "전화번호" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "phoneNumber",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editableOrganizationDetails.value.phoneNumber,
                                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((editableOrganizationDetails.value.phoneNumber) = $event)),
                                  placeholder: "대표 전화번호 (예: 02-123-4567)"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "담당자 이름" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "deptPersonName",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editableOrganizationDetails.value.deptPersonName,
                                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((editableOrganizationDetails.value.deptPersonName) = $event)),
                                  placeholder: "담당자 이름"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "이메일" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "email",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editableOrganizationDetails.value.email,
                                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((editableOrganizationDetails.value.email) = $event)),
                                  placeholder: "대표 이메일 주소"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "설명",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "description",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editableOrganizationDetails.value.description,
                                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((editableOrganizationDetails.value.description) = $event)),
                                  type: "textarea",
                                  placeholder: "기관에 대한 간략한 설명 (선택 사항)"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (selectedOrganization.value.admin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _cache[62] || (_cache[62] = _createElementVNode("h4", { class: "details-subtitle" }, "관리자 정보", -1)),
                          _createVNode(_unref(NDescriptions), {
                            "label-placement": "left",
                            bordered: "",
                            column: 1,
                            size: "small",
                            class: "admin-details-table"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NDescriptionsItem), null, {
                                label: _withCtx(() => _cache[60] || (_cache[60] = [
                                  _createElementVNode("div", { class: "description-item-label-fixed-width" }, "기관 관리자 ID", -1)
                                ])),
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("span", null, _toDisplayString(selectedOrganization.value.admin.SK && selectedOrganization.value.admin.SK.includes("#")
                          ? selectedOrganization.value.admin.SK.split("#")[2] // "org#id#admin" -> "admin"
                          : selectedOrganization.value.admin.SK), 1),
                                    _createVNode(_unref(NButton), {
                                      size: "small",
                                      type: "warning",
                                      ghost: "",
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (resetOrgAdminPassword(selectedOrganization.value.SK))),
                                      style: {"margin-left":"auto"}
                                    }, {
                                      default: _withCtx(() => _cache[61] || (_cache[61] = [
                                        _createTextVNode("비밀번호 재설정")
                                      ])),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_unref(NButton), {
                        onClick: closeDetailsModal,
                        type: "tertiary",
                        style: {"margin-right":"10px"}
                      }, {
                        default: _withCtx(() => _cache[63] || (_cache[63] = [
                          _createTextVNode("취소")
                        ])),
                        _: 1
                      }),
                      _createVNode(_unref(NButton), {
                        onClick: handleUpdateOrganization,
                        type: "primary",
                        loading: isUpdating.value
                      }, {
                        default: _withCtx(() => _cache[64] || (_cache[64] = [
                          _createTextVNode("수정")
                        ])),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(NModal), {
            show: showRegistrationForm.value,
            "onUpdate:show": _cache[34] || (_cache[34] = ($event: any) => ((showRegistrationForm).value = $event)),
            preset: "card",
            style: {"width":"800px"},
            title: "신규 기관 등록"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_unref(NForm), {
                  ref_key: "registrationFormRef",
                  ref: registrationFormRef,
                  model: registrationModel.value,
                  rules: registrationRules,
                  "label-placement": "left",
                  "require-mark-placement": "right-hanging"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "left",
                      bordered: "",
                      column: 2,
                      size: "small",
                      class: "compact-descriptions"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "기관 ID",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "uid",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInputGroup), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NInput), {
                                      value: registrationModel.value.uid,
                                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((registrationModel.value.uid) = $event)),
                                      placeholder: "영문, 숫자 조합 (예: coko)"
                                    }, null, 8, ["value"]),
                                    _createVNode(_unref(NButton), {
                                      type: "primary",
                                      ghost: "",
                                      onClick: checkOrganizationId,
                                      loading: isCheckingId.value
                                    }, {
                                      default: _withCtx(() => _cache[65] || (_cache[65] = [
                                        _createTextVNode("중복 체크")
                                      ])),
                                      _: 1
                                    }, 8, ["loading"])
                                  ]),
                                  _: 1
                                }),
                                (idCheckMessage.value)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(isIdAvailable.value ? 'success-message' : 'error-message'),
                                      style: {"font-size":"0.9em","margin-top":"4px"}
                                    }, _toDisplayString(idCheckMessage.value), 3))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "기관명",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "name",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: registrationModel.value.name,
                                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((registrationModel.value.name) = $event)),
                                  placeholder: "기관 전체 이름"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "대표자 이름",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "president",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: registrationModel.value.president,
                                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((registrationModel.value.president) = $event)),
                                  placeholder: "대표자 이름"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "기관 유형",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "type",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NSelect), {
                                  value: registrationModel.value.type,
                                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((registrationModel.value.type) = $event)),
                                  placeholder: "기관 유형 선택",
                                  options: typeOptions.value
                                }, null, 8, ["value", "options"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "우편번호",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "address.postCode",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInputGroup), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NInput), {
                                      value: registrationModel.value.address.postCode,
                                      "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((registrationModel.value.address.postCode) = $event)),
                                      placeholder: "우편번호",
                                      style: {"width":"120px"},
                                      disabled: true,
                                      class: "force-black-text-disabled"
                                    }, null, 8, ["value"]),
                                    _createVNode(_unref(NButton), {
                                      type: "primary",
                                      ghost: "",
                                      onClick: openPostcodeSearch,
                                      size: "small",
                                      style: {"margin-left":"5px !important"}
                                    }, {
                                      default: _withCtx(() => _cache[66] || (_cache[66] = [
                                        _createTextVNode(" 주소검색 ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "주소",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "address.address",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: registrationModel.value.address.address,
                                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((registrationModel.value.address.address) = $event)),
                                  placeholder: "주소",
                                  disabled: true,
                                  class: "force-black-text-disabled"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "상세주소",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "address.addressDetail",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  id: "addressDetailInput",
                                  value: registrationModel.value.address.addressDetail,
                                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((registrationModel.value.address.addressDetail) = $event)),
                                  placeholder: "상세주소",
                                  class: "force-black-text-disabled"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "담당부서" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "dept",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: registrationModel.value.dept,
                                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((registrationModel.value.dept) = $event)),
                                  placeholder: "담당부서 이름"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "전화번호" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "phoneNumber",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: registrationModel.value.phoneNumber,
                                  "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((registrationModel.value.phoneNumber) = $event)),
                                  placeholder: "대표 전화번호 (예: 02-123-4567)"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "담당자 이름" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "deptPersonName",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: registrationModel.value.deptPersonName,
                                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((registrationModel.value.deptPersonName) = $event)),
                                  placeholder: "담당자 이름"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "담당자 연락처" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "deptPersonPhoneNumber",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: registrationModel.value.deptPersonPhoneNumber,
                                  "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((registrationModel.value.deptPersonPhoneNumber) = $event)),
                                  placeholder: "담당자 연락처"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "담당자 이메일",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "email",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: registrationModel.value.email,
                                  "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((registrationModel.value.email) = $event)),
                                  placeholder: "대표 이메일 주소"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "설명",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "description",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: registrationModel.value.description,
                                  "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((registrationModel.value.description) = $event)),
                                  type: "textarea",
                                  placeholder: "기관에 대한 간략한 설명 (선택 사항)"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_unref(NButton), {
                  onClick: _cache[33] || (_cache[33] = ($event: any) => (showRegistrationForm.value = false)),
                  type: "tertiary",
                  style: {"margin-right":"10px"}
                }, {
                  default: _withCtx(() => _cache[67] || (_cache[67] = [
                    _createTextVNode("취소")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(NButton), {
                  type: "primary",
                  loading: isRegisting.value,
                  onClick: handleRegistrationSubmit
                }, {
                  default: _withCtx(() => _cache[68] || (_cache[68] = [
                    _createTextVNode("등록")
                  ])),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(NModal), {
            show: showUserManagementModal.value,
            "onUpdate:show": _cache[35] || (_cache[35] = ($event: any) => ((showUserManagementModal).value = $event)),
            preset: "card",
            style: {"width":"1000px","max-width":"95vw","max-height":"85vh"},
            title: selectedOrgForUserManagement.value ? `사용자 관리 - ${selectedOrgForUserManagement.value.name}` : '사용자 관리'
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                vertical: "",
                size: 12
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_unref(NButton), {
                      type: "primary",
                      onClick: openAddUserForm
                    }, {
                      default: _withCtx(() => _cache[69] || (_cache[69] = [
                        _createTextVNode("사용자 추가")
                      ])),
                      _: 1
                    })
                  ]),
                  (loadingOrgMembers.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_unref(NSpin), { size: "medium" }),
                        _cache[70] || (_cache[70] = _createElementVNode("div", { style: {"margin-top":"8px"} }, "사용자 목록을 불러오는 중...", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_unref(NDataTable), {
                          columns: userTableColumns,
                          data: orgMembers.value,
                          pagination: { pageSize: 5 },
                          bordered: true
                        }, null, 8, ["data"])
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show", "title"]),
          _createVNode(_unref(NModal), {
            show: showUserEditModal.value,
            "onUpdate:show": _cache[47] || (_cache[47] = ($event: any) => ((showUserEditModal).value = $event)),
            preset: "card",
            style: {"width":"600px","max-width":"90vw"},
            title: isEditingUser.value ? '사용자 정보 수정' : '사용자 추가',
            closable: !isSavingUser.value,
            "mask-closable": !isSavingUser.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                vertical: "",
                size: 12
              }, {
                default: _withCtx(() => [
                  (isEditingUser.value)
                    ? (_openBlock(), _createBlock(_component_n_alert, {
                        key: 0,
                        type: "warning",
                        title: "주의 사항",
                        style: {"margin-bottom":"10px"}
                      }, {
                        default: _withCtx(() => _cache[71] || (_cache[71] = [
                          _createTextVNode(" 사용자 정보를 수정하더라도 이미 이 사용자가 담당자로 지정된 기존 진단 정보(학급 정보 등)에는 자동으로 반영되지 않습니다. 기존 진단의 담당자 정보도 함께 업데이트하려면, 해당 진단의 상세 화면에서 '담당자 변경' 기능을 사용하여 재설정해 주시기 바랍니다. ")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(NForm), {
                    ref_key: "userEditFormRef",
                    ref: userEditFormRef,
                    model: userEditFormData.value,
                    rules: userEditFormRules.value,
                    "label-placement": "left",
                    "label-width": "100"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NFormItem), {
                        path: "uid",
                        label: "아이디"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NInput), {
                            value: userEditFormData.value.uid,
                            "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((userEditFormData.value.uid) = $event)),
                            placeholder: "아이디를 입력해주세요",
                            disabled: isEditingUser.value || isSavingUser.value
                          }, null, 8, ["value", "disabled"])
                        ]),
                        _: 1
                      }),
                      (!isEditingUser.value)
                        ? (_openBlock(), _createBlock(_unref(NFormItem), {
                            key: 0,
                            path: "password",
                            label: "암호"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NInput), {
                                value: userEditFormData.value.password,
                                "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((userEditFormData.value.password) = $event)),
                                type: "password",
                                placeholder: "암호를 입력해주세요",
                                "show-password-on": "mousedown",
                                disabled: isSavingUser.value
                              }, null, 8, ["value", "disabled"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!isEditingUser.value)
                        ? (_openBlock(), _createBlock(_unref(NFormItem), {
                            key: 1,
                            path: "confirmPassword",
                            label: "암호 확인"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NInput), {
                                value: userEditFormData.value.confirmPassword,
                                "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((userEditFormData.value.confirmPassword) = $event)),
                                type: "password",
                                placeholder: "암호를 다시 입력해주세요",
                                "show-password-on": "mousedown",
                                disabled: isSavingUser.value
                              }, null, 8, ["value", "disabled"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(NFormItem), {
                        path: "name",
                        label: "이름"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NInput), {
                            value: userEditFormData.value.name,
                            "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((userEditFormData.value.name) = $event)),
                            placeholder: "이름을 입력해주세요",
                            disabled: isSavingUser.value
                          }, null, 8, ["value", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), {
                        path: "email",
                        label: "이메일"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NInput), {
                            value: userEditFormData.value.email,
                            "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((userEditFormData.value.email) = $event)),
                            placeholder: "이메일을 입력해주세요",
                            disabled: isSavingUser.value
                          }, null, 8, ["value", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), { label: "전화번호" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NInput), {
                            value: userEditFormData.value.phoneNumber,
                            "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((userEditFormData.value.phoneNumber) = $event)),
                            placeholder: "전화번호를 입력해주세요",
                            disabled: isSavingUser.value
                          }, null, 8, ["value", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), { label: "구분" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NSelect), {
                            value: userEditFormData.value.type,
                            "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((userEditFormData.value.type) = $event)),
                            options: [
                    { label: '일반사용자', value: 'user' },
                    { label: '관리자', value: 'admin' }
                  ],
                            disabled: isSavingUser.value
                          }, null, 8, ["value", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), { label: "역할" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NInput), {
                            value: userEditFormData.value.role,
                            "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((userEditFormData.value.role) = $event)),
                            placeholder: "역할을 입력해주세요 (예: 교사, 강사)",
                            disabled: isSavingUser.value
                          }, null, 8, ["value", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), { label: "직책" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NInput), {
                            value: userEditFormData.value.position,
                            "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((userEditFormData.value.position) = $event)),
                            placeholder: "직책을 입력해주세요 (예: 담임, 주임)",
                            disabled: isSavingUser.value
                          }, null, 8, ["value", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), { label: "설명" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NInput), {
                            value: userEditFormData.value.description,
                            "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((userEditFormData.value.description) = $event)),
                            type: "textarea",
                            placeholder: "설명을 입력해주세요",
                            disabled: isSavingUser.value,
                            autosize: { minRows: 2, maxRows: 4 }
                          }, null, 8, ["value", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "rules"]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_unref(NButton), {
                      disabled: isSavingUser.value,
                      onClick: _cache[46] || (_cache[46] = ($event: any) => (showUserEditModal.value = false)),
                      style: {"margin-right":"8px"}
                    }, {
                      default: _withCtx(() => _cache[72] || (_cache[72] = [
                        _createTextVNode("취소")
                      ])),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_unref(NButton), {
                      type: "primary",
                      loading: isSavingUser.value,
                      onClick: handleUserEditSubmit
                    }, {
                      default: _withCtx(() => _cache[73] || (_cache[73] = [
                        _createTextVNode("저장")
                      ])),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show", "title", "closable", "mask-closable"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})